<template>
  <b-container>
  <div style="margin: 1rem 0 0 0;">
    <b-row>
    <b-col md="1" style="max-width:3rem;">
       <b-button v-if="!is_locked" variant="outline-secondary" @click="toggleLock">
          L O C K </b-button>
       <b-button v-if="is_locked" variant="danger" @click="toggleLock">
          L O C K </b-button>
    </b-col>
    <b-col>
    <b-row>
      <b-col md="5">
        <div @click="downloaded_file">
          <a download="info.txt" id="downloadlink" style="display: none">
             Click To Download File
          </a>
        </div>
        <b-button v-if="!saveFile"
          :disabled="!enableSave()"
          @click="make_save_file">
          Save
        </b-button>
        <b-input v-if="!saveFile"
         style="width:auto;display:inline-block;max-width:60%"
         placeholder="Save As Filename"
         v-model="saveFileName"
         >
        </b-input>
      </b-col>
      <b-col md="7">
        <b-button v-if="!saveFile && !is_locked"
          :disabled="!loadFile"
          @click="load_from_file">
          Load
        </b-button>
        <b-form-file v-if="!saveFile && !is_locked"
           style="width:auto;display:inline-block;max-width:60%"
           v-model="loadFile" size="sm" plain
           :state="Boolean(loadFile)">
        </b-form-file>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="7">
        <b-button
          v-if="!is_locked"
          :disabled="!input.email"
          @click="addPresenter">
          Add
        </b-button>
        <b-input
          v-if="!is_locked"
          style="width:auto;display:inline-block;max-width:60%"
          placeholder="Email of Presenter to Add"
          v-on:keyup='addPresenterKP'
          v-model="input.email">
        </b-input>
      </b-col>
      <b-col md="4">
        <span
          style="font-size:1.1rem;line-height:2.5rem;">
          # Panelists
        </span>
        <b-input
          style="width:auto;display:inline-block;max-width:40%"
          :disabled="is_locked"
          placeholder="1 to 4"
          v-on:keyup='update_panelist_cnt'
          v-model="num_panelists">
        </b-input>
      </b-col>
    </b-row>
    </b-col>
    <b-col md="3">
        <!-- MEETING SPOT 3 -->
        <div>
          <span style="color:blue;"> {{ meeting.name }} </span>
        <div>
          <span> {{ meeting.msg }} </span>
        </div>
        </div>
        <div v-if="meeting.end_ep">
          <span> {{ meeting.acnt }} Attendees </span>
        </div>
    </b-col> </b-row>
 
    <b-row style="border-top: 2px solid; padding: 0.5rem 0;">
    </b-row>
    <b-row>
      <b-col md="6">
        <b-button
          :variant="variant_hostonly"
          style="width:100%;"
          @click="layout_hostonly">
          Presentation Mode ({{ ly_hostonly_txt }})
        </b-button>
      </b-col>
      <b-col>
        <b-button
          style="float:right"
          @click="refreshAll">
          Refresh
        </b-button>
      </b-col>
    </b-row>
    <b-row>
      <b-col md="6">
        <b-button
          style="width:100%;"
          :variant="variant_qna"
          @click="layout_qna">
          Q&A Mode ({{ ly_qna_txt }})
        </b-button>
      </b-col>
      <b-col>
        <b-button
          v-if="owner.kind == 'prs'"
          style="float:right" variant="warning"
          @click="do_host_audioonly">
          Host On-screen. Click for audio only.
        </b-button>
        <b-button
          v-if="owner.kind == 'mod'"
          style="float:right" variant="primary"
          @click="do_host_raise">
          Host is Audio Only. Click to show.
        </b-button>
        <b-button
          v-if="owner.kind == 'aud'"
          style="float:right" variant="primary"
          @click="do_host_raise">
          Host in Audience. Click to show.
        </b-button>
        <b-button
          v-if="!owner.kind"
          style="float:right" variant="secondary" disabled          
          >
          Host is not in the room.
        </b-button>
      </b-col>
    </b-row>
    <b-row style="border-top: 2px solid; padding: 0.5rem 0;">
    </b-row>
    <b-row>
        People Asking Questions ({{ qna_cnt }} Hands Raised)
        <b-table striped show-empty stacked="md"
         :fields="qnaFields"
         :items="qna"
         empty-text="No one has their hand raised."
         small>
          <template v-slot:cell(uid)="data">
            <b-button v-if="!eject_uid"
              class="btn_ctrl" size="sm" style="float:right"
              variant="danger" @click="do_eject(data.item)">
              Eject
            </b-button>
            <b-button v-if="eject_uid == data.item.uid"
              class="btn_ctrl" size="sm" style="float:right"
              variant="danger" @click="do_eject(data.item)">
              Confirm Eject
            </b-button>
            <b-button
              class="btn_ctrl" size="sm" style="float:right"
              variant="info" @click="do_lower_hand(data.item)">
              Lower Hand
            </b-button>
          </template>
        </b-table>
    </b-row>
    <b-row style="border-top: 2px solid; padding: 0.5rem 0;">
    </b-row>
    <b-row>
        Schedule Of Presenters
        <b-table striped show-empty stacked="md"
         :fields="presenterFields"
         :items="presenters"
         empty-text="Add a presenter to the schedule or load a schedule from a file."
         small>
          <template v-slot:cell(idx)="data">
             {{ data.item.idx+1 }}
          </template>
          <template v-slot:cell(email)="data">
             {{ data.item.email }}
          </template>
          <template v-slot:cell(d)="data">
             {{ data.item.state.d }}
          </template>
          <template v-slot:cell(kind)="data">
             {{ data.item.state.kind }}
          </template>
          <template v-slot:cell(btn)="data">
            <b-button v-if="!is_locked"
              class="btn_ctrl" size="sm" style="float:right"
              variant="danger" @click="remove_presenter(data.item)">
              Del
            </b-button>
            <b-button v-if="!is_locked"
              class="btn_ctrl" size="sm" style="float:right"
              variant="info" @click="move_up(data.item)">
              Up
            </b-button>
            <b-button v-if="!is_locked"
              class="btn_ctrl" size="sm" style="float:right"
              variant="info" @click="move_down(data.item)">
              Down
            </b-button>
            <b-button v-if="data.item.state.is_pres"
              class="btn_ctrl" size="sm" style="float:right"
              variant="warning" @click="do_lower_hand(data.item)">
              Return to Audience
            </b-button>
            <b-button v-if="data.item.state.is_here && !data.item.state.is_pres"
              class="btn_ctrl" size="sm" style="float:right"
              variant="warning" @click="do_make_pres(data.item)">
              Make Presenter
            </b-button>
           </template>
        </b-table>
    </b-row>
  </div>
  </b-container>
</template>

<script>
  import { sync } from "vuex-pathify";
  import store from "../store";
  import vx_api from "../vuemix";
  import { format, getUnixTime } from 'date-fns';

  export default {
  name: "hall",
  data() {
    return {
      addlistener: true,
      eject_uid: null,
      num_panelists: 1,
      is_locked: false,
      current_time: "",
      saveFile: null,
      saveFileName: "",
      ly_hostonly:"1x1p6",
      ly_hostonly_txt:"1",
      ly_qna:"2x1p6",
      ly_qna_txt:"2",
      variant_hostonly: "",
      variant_qna: "",
      loadFile: null,
      input: {
        email:"",
      },
      meeting: {
        name: "-",
        msg: "-",
        start_ep: 0,
      },
      presenters:[],
      presenterFields:[
          { key: "idx", label: ""},
          { key: "email", label: ""},
          { key: "d", label: ""},
          { key: "kind", label: ""},
          { key: "timer", label: ""},
          { key: "btn", label: ""},
      ],
      qna:[],
      qna_cnt: 0,
      qnaFields:[
          { key: "d", label: ""},
          { key: "uid", label: ""},
      ],
      owner: {},
    };
  },
  components: {
  },
  created() {
  },
  mounted() {
    let vue=this;
    vue.init_page();
    window.clearTimeout(vue.time_tid);
    vue.time_tid = setInterval(function() {
      vue.current_time = format(Date.now(),'E h:mm:ss a');
      vue.updateMeeting();
      if (vue.pres_p) {
         let delta = (Date.now() - vue.pres_p.start_ep)/1000;
         let min = (delta/60).toFixed(0);
         let sec = (delta % 60).toFixed(0);
         if (sec.length < 2) { sec = "0"+sec; }
         vue.pres_p.timer = min+":"+sec;
      }
    }, 1000);
    window.clearTimeout(vue.refr_tid);
    vue.refr_tid = setInterval(function() {
      vue.refreshAll();
    }, 120000);
  },
  beforeDestroy() {
    let vue=this;
    window.wss_clr_routes(window.vx,"hall");
    document.removeEventListener("keydown", vue.handle_keypress);
    vue.addlistener = true;
    window.clearTimeout(vue.time_tid);
    window.clearTimeout(vue.refr_tid);
  },
  methods: {
     updateMeeting: function() {
       let vue = this;
       let m = vue.meeting;
       let now = Date.now()/1000;
       if (m.start_ep <= 1000) {
         m.start_ep += 1;
         if (m.start_ep == 30) {
             wss_send(vx, "get_meetings", {tgt_em:"_anchor_",for_tm:"curhour"});
             m.start_ep = 0;
         }
       } else if (m.start_ep <= (now+2)) {
          if (m.end_ep >= now+60) {
            let left = ((59 + m.end_ep - now)/60).toFixed(0);
            vue.meeting.msg = ""+left+" min left";
          } else {
            let left = ((m.end_ep - now)).toFixed(0);
            vue.meeting.msg = ""+left+" sec left";
          }
          if (m.end_ep <= (now+1)) {
             vue.meeting.name = "-";
             vue.meeting.msg = "";
             vue.meeting.acnt = 0;
             vue.meeting.start_ep = 27;
             vue.meeting.end_ep = 0;
          }
       } else if (m.start_ep > (now+60)) {
          let unt = ((59 + m.start_ep - now)/60).toFixed(0);
          vue.meeting.msg = "starts in "+unt+"min";
       } else {
          let unt = ((m.start_ep - now)).toFixed(0);
          vue.meeting.msg = "starts in "+unt+"sec";
       }
     },
     toggleLock: function() {
       this.is_locked = !this.is_locked;
     },
     enableSave: function() {
       let vue = this;
       if (vue.saveFile) { return false; }
       if (vue.loadFile) { return false; }
       if (!vue.saveFileName) { return false; }
       return true;
     },
     addPresenterKP: function(e) {
       if (this.is_locked) { return; }
       if (e.keyCode === 13) {
          this.addPresenter();
       }
     },
     addPresenter_internal: function(em, uid, cb) {
       let vue = this;
       if (!em) { return; }       
       for (let i=0; i<vue.presenters.length; i++) {
          let p = vue.presenters[i];
          if (p.email == em) {
             let idx = vue.presenters.length;
             vue.presenters.push({idx:idx, email:em, d:"", kind:"", state:p.state});
             if (cb) { cb(); }
             return;
          }
       }
       if (!uid) {
          vx_api
            .getUID(window.vx, { em: em })
            .then( res => {
                 let state = {em:em, is_here: false, is_pres:false, kind:"not registered"};
                 if (res.uid) {
                    state.uid = res.uid;
                    state.kind = "not here";
                 }
                 let idx = vue.presenters.length;
                 vue.presenters.push({idx:idx, email:em, d:"", kind:"", state:state});
                 if (cb) { cb(); }
               });
       } else {
          let state = {em:em, uid:uid, is_here: false, is_pres:false, kind:"not here"};
          let idx = vue.presenters.length;
          vue.presenters.push({idx:idx, email:em, d:"", kind:"", state:state});
          if (cb) { cb(); }
       }
     },
     addPresenter: function() {
       let vue = this;
       let em = vue.input.email.toLowerCase();
       vue.addPresenter_internal(em, null, function() {
         vue.input.email = "";
         vue.refreshList();
       });
     },
     refreshUIDs: function() {
       let vue = this;
       vue.presenters.forEach(function(p) {
         if (p.state.uid) { return; }
         vx_api
           .getUID(window.vx, { em: p.email })
           .then( res => {
              if (res.uid) {
                p.state.uid = res.uid;
                p.state.kind = "not here";
              }
           });
       });
     },
     refreshSelf: function() {
       vx_api.getSelf(window.vx);
     },
     refreshList: function() {
       this.do_list_room();
     },
     refreshAll: function() {
       this.refreshUIDs();
       this.refreshSelf();
       this.refreshList();
     },
     init_page() {
       let vue = this;
       vue.select_layouts();
       window.vx_set_room(vx,
          vue.$router.currentRoute.params.acc,
          vue.$router.currentRoute.params.uid,
          "scheduler");
       window.wss_open(vx, {
         acc: vx.room.acc,
         room: vx.room.name,
         uid: vx.user.id,
         routes_id: "hall",
         routes: {         
           auth_me: function(msg) {
             if (vx.acc == vx.room.acc && vx.room.name == vx.user.my_room_name) {
               wss_send(vx, "auth_room", {"cred":vx.user.creds["myroom"]});
             } else {
               wss_send(vx, "auth_room", {});
             }
           },
           auth_room: function() {
             vue.do_list_room();
             vue.layout_hostonly();
             wss_send(vx, "get_meetings", {tgt_em:"_anchor_",for_tm:"curhour"});
           },
           room: function(msg) {
             vue.do_list_room();
             vue.handle_user_exit(msg.data);
           },
           room_ctrl: function(msg) {
             if (!msg || !msg.data || !msg.data.state) { return; }
             if (msg.data.state.pl == vue.ly_hostonly) {
               vue.variant_hostonly = "primary";
               vue.variant_qna = "outline-primary";
             } else {
               vue.variant_hostonly = "outline-primary";
               vue.variant_qna = "primary";
             }
           },
           list_room: vue.handle_list_room,
           list_user: vue.handle_list_user,
           get_meetings: function(msg) {
             if (!wss_ishash(msg)) { return; }
             let m = msg.data[0];
             if (!m) { return; }
             vue.meeting.start_ep = m.start_ep;
             vue.meeting.end_ep = m.end_ep;
             vue.meeting.acnt = m.regcnt;
             vue.meeting.name = m.name;
             vue.updateMeeting();
           }
         },
       });
       if (vue.addlistener) {
         document.addEventListener("keydown", vue.handle_keypress);
         vue.addlistener = false;
       }
       vue.handle_list_room();
     },
     handle_new_join: function(data) {
       if (data.k != "user_joined") { return; }
     },
     handle_user_exit: function(data) {
       let vue = this;
       if (data.k != "user_exited") { return; }
       let uid = data.uid;
       let p = vue.getPresenterByUID(uid);
       if (!p) { return; }
       if (vue.pres_p && vue.pres_p.state.uid == uid) {
          vue.pres_p = null;
       }
       p.state.kind = "not here";
       p.state.is_pres = false;
       p.state.is_here = false;       
     },
     handle_keypress: function(et) {
       let vue = this;
       if (et.isComposing || et.keyCode === 229) {
         return;
       }     
     },
     do_lower_hand_all: function() {
       let vue = this;
       vue.pres_p = null;
       window.wss_send(vx, "lower_hand", {tgt_uid: "all"});
     },
     do_lower_hand: function(u) {
       let vue = this;
       if (vue.pres_p && vue.pres_p.idx == u.idx) {
         vue.pres_p = null;
       }
       if (u.state) {
         window.wss_send(vx, "lower_hand", {tgt_uid: u.state.uid});
       } else {
         /* 'u' is NOT a presenter object. Just d and uid. */
         window.wss_send(vx, "lower_hand", {tgt_uid: u.uid});
       }
     },
     do_eject: function(u) {
       let vue = this;
       if (!vue.eject_uid) {
         vue.eject_uid = u.uid;
         setTimeout(function() {
            vue.eject_uid = null;
         }, 3000);
       } else if (u.uid == vue.eject_uid) {
         window.wss_send(vx, "exit_room", {tgt_uid: u.uid, blklist:true});
       }
     },
     do_host_unmute: function() {
       let vue = this;
       if (!vue.owner.muted) { return; }
       let up = {};
       up.tgt_uid = vue.owner.uid;
       up.state = {blk:0};
       wss_send(vx, "update_user_state", up);
     },
     do_host_mute: function() {
       let vue = this;
       if (vue.owner.muted) { return; }
       let up = {};
       up.tgt_uid = vue.owner.uid;
       up.state = {blk:1};
       wss_send(vx, "update_user_state", up);
     },
     do_host_raise: function() {
       let vue = this;
       vue.do_host_unmute();
       window.wss_send(vx, "raise_hand", {tgt_uid: vue.owner.uid, tgt_to:"prs"});
     },
     do_host_audioonly: function() {
       let vue = this;
       vue.do_host_unmute();
       window.wss_send(vx, "raise_hand", {tgt_uid: vue.owner.uid, tgt_to:"mod"});
     },
     do_make_pres: function(u) {
       let vue = this;
       vue.pres_p = u;
       u.start_ep = Date.now();
       window.wss_send(window.vx, "raise_hand", {tgt_uid: u.state.uid, tgt_to:"prs"});
     },
     do_list_room: function() {
       window.wss_send(window.vx, "list_room", {limit:200});
     },
     getPresenterByUID: function(uid) {
       let vue = this;
       for (let i=0; i<vue.presenters.length; i++) {
          let p = vue.presenters[i];
          if (p.state.uid == uid) {
             return p;
          }
       }
       return null;
     },
     handle_list_user: function(msg) {
       let vue = this;
       if (!wss_ishash(msg)) { return; }
       if (msg.data.roles && msg.data.roles.is_owner) {
           let it = msg.data;
           vue.owner.dname = it.dname;
           vue.owner.uid = it.uid;
           vue.owner.kind = it.kd;
           if (it.sa.blk) {
             vue.owner.muted = true;
           } else {
             vue.owner.muted = false;
           }
       }
     },
     handle_list_room: function(msg) {
       let vue = this;
       if (!wss_ishash(msg)) { return; }
       vue.qna = [];
       vue.qna_cnt = 0;
       for (let i=0; i<msg.data.length; i++) {
         let it = msg.data[i];
         if (it.roles && it.roles.is_owner) {
           vue.owner.dname = it.dname;
           vue.owner.uid = it.uid;
           vue.owner.kind = it.kind;
           if (it.sa.blk) {
             vue.owner.muted = true;
           } else {
             vue.owner.muted = false;
           }
         }
         if (it.kind == "inl") {
           if (vue.qna.length < 3) {
             vue.qna.push({d:it.dname, uid:it.uid});
           }
           vue.qna_cnt++;
         }
         let p = vue.getPresenterByUID(it.uid);
         if (!p) { continue; }
         vue.$set(p.state, "is_pres", false);
         vue.$set(p.state, "is_here", true);
         if (it.kind == "prs") {
           vue.$set(p.state, "kind", "Presenter");
           vue.$set(p.state, "is_pres", true);
         } else if (it.kind == "mod") {
           vue.$set(p.state, "kind", "Moderator");
         } else if (it.kind == "inl") {
           vue.$set(p.state, "kind", "Hand Raised");
         } else if (it.kind == "aud") {
           vue.$set(p.state, "kind", "Audience");
         } else {
           vue.$set(p.state, "kind", "??");
         }
         vue.$set(p.state, "d", it.dname);
       }
     },
     array_move: function(arr, old_index, new_index) {
       if (new_index >= arr.length) {
           var k = new_index - arr.length + 1;
           while (k--) {
             arr.push(undefined);
           }
       }
       arr.splice(new_index, 0, arr.splice(old_index, 1)[0]);
       for (let i=0; i<arr.length; i++) {
         arr[i].idx = i;
       }
       return arr; // for testing
     },
     move_up: function(p) {
       let vue = this;
       let i = p.idx;
       //console.log("move_up:"+i);
       if (!i) { return; }
       vue.array_move(vue.presenters, i, i-1);
     },
     move_down: function(p) {
       let vue = this;
       let i = p.idx;
       //console.log("move_down:"+i);
       if (!i || i >= vue.presenters.length-1) { return; }
       vue.array_move(vue.presenters, i, i+1);
     },
     remove_presenter: function(p) {
       let vue = this;
       if (!i && i !== 0) { return; }
       vue.presenters.splice(p.idx, 1);
     },
     make_save_file: function() {
       let vue = this;
       let j = []
       vue.presenters.forEach(function(p) {
         let jp = {};
         jp.email = p.email;
         jp.uid = p.state.uid;
         j.push(jp);
       });
       let data = new Blob([JSON.stringify(j)], {type: 'text/plain'});
       if (vue.saveFile !== null) {
         window.URL.revokeObjectURL(vue.saveFile);
       }
       vue.saveFile = window.URL.createObjectURL(data);

       let link = document.getElementById('downloadlink');
       link.href = vue.saveFile;
       link.style.display = 'block';
       link.download = ""+vue.saveFileName;
     },
     downloaded_file: function() {
       let vue = this;
       window.setTimeout(function() {
         let link = document.getElementById('downloadlink');
         link.href = null;
         link.style.display = 'none';
         if (vue.saveFile !== null) {
           window.URL.revokeObjectURL(vue.saveFile);
         }
         vue.saveFile = null;
       }, 2000);
     },
     load_from_file: function() {
       let vue = this;
       let reader = new FileReader();
       vue.presenters = [];
       reader.onload = function(e) {
         let contents = e.target.result;
         let j = to_json(contents);
         j.forEach(function(p) {
           vue.addPresenter_internal(p.email, p.uid);
         });
         vue.loadFile = null;
         setTimeout(vue.refreshAll, 3000);
       }
       reader.readAsText(vue.loadFile);
     },
     layout_hostonly: function() {
       let vue = this;
       let c = { set_ctrl: {state:{}} };
       c.set_ctrl.state.pl = vue.ly_hostonly;
       c.set_ctrl.state.al = "4x3a";
       /* Set 1-at-a-time queue audio mode */
       c.set_ctrl.state.ac = 1;
       c.set_ctrl.state.prv = false;
       window.wss_send(window.vx, "set_room_ctrl", c);
     },
     layout_qna: function() {
       let vue = this;
       let c = { set_ctrl: {state:{}} };
       c.set_ctrl.state.pl = vue.ly_qna;
       c.set_ctrl.state.al = "4x3a";
       /* Set 1-at-a-time queue audio mode */
       c.set_ctrl.state.ac = 1;
       c.set_ctrl.state.prv = false;
       window.wss_send(window.vx, "set_room_ctrl", c);
     },
     select_layouts: function() {
       let vue = this;
       if (!vue.num_panelists) { return false; }
       if (vue.num_panelists <= 1) {
          vue.num_panelists = 1;
          vue.ly_hostonly = "1x1p6";
          vue.ly_qna = "2x1p6";
          vue.ly_hostonly_txt = "1";
          vue.ly_qna_txt = "2";
       } else if (vue.num_panelists == 2) {
          vue.ly_hostonly = "2x1p6";
          vue.ly_qna = "2x2p6";
          vue.ly_hostonly_txt = "2";
          vue.ly_qna_txt = "4";
       } else if (vue.num_panelists == 3) {
          vue.ly_hostonly = "2x2p6";
          vue.ly_qna = "2x2p6";
          vue.ly_hostonly_txt = "4";
          vue.ly_qna_txt = "4";
       } else if (vue.num_panelists >= 4) {
          vue.num_panelists = 4;          
          vue.ly_hostonly = "2x2p6";
          vue.ly_qna = "3x3p6";
          vue.ly_hostonly_txt = "4";
          vue.ly_qna_txt = "9";
       }
       return true;
     },
     update_panelist_cnt: function() {
       let vue = this;
       if (vue.select_layouts()) {
         vue.layout_hostonly();
       }
     },
  },
  computed: {
  },
};
</script>

<style lang="scss" scoped>
.container {
  position:relative;
  /*height:90vh;*/
  max-width:90vw;
  padding:0;
}
.btn_ctrl {
  margin: 0 0.5rem;
  padding:0.1rem;
  font-weight: 700;
}
</style>
